// AddAdmin.js
import { useState } from "react";
import { addAdmin } from "../../service/Mainservice";
import "./AddAdmin.css";

// MUI Icons
import PersonAddIcon from "@mui/icons-material/PersonAdd";

const AddAdmin = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    mobilenumber: "",
    role: "Support Agent",
    permissions: [],
  });
  const [success, setSuccess] = useState(false);

  const availableRoles = [
    "Superadmin",
    "Admin",
    "Manager",
    "Support Agent",
    "Finance",
    "Operations",
    "Read-Only",
  ];

  // Predefined permission sets by role (for quick selection)
  const rolePermissionsMap = {
    "Support Agent": ["manage_support", "support_tickets"],
    Finance: ["manage_finance", "view_reports"],
    Manager: [
      "manage_orders",
      "manage_support",
      "manage_stores",
      "approve_stores",
      "manage_drivers",
      "approve_drivers",
      "manage_products",
      "manage_marketing",
      "view_reports",
      "refund",
    ],
    Admin: [
      "manage_orders",
      "manage_support",
      "manage_stores",
      "approve_stores",
      "manage_drivers",
      "approve_drivers",
      "manage_products",
      "manage_finance",
      "manage_settings",
      "manage_team",
      "support_tickets",
      "manage_marketing",
      "view_reports",
      "refund",
    ],
    Operations: [
      "manage_orders",
      "manage_drivers",
      "manage_stores",
      "view_reports",
    ],
    "Read-Only": ["view_reports"],
  };

  const allPermissions = [
    "manage_orders",
    "manage_support",
    "manage_stores",
    "approve_stores",
    "manage_drivers",
    "approve_drivers",
    "manage_products",
    "manage_finance",
    "manage_settings",
    "manage_team",
    "support_tickets",
    "manage_marketing",
    "view_reports",
    "refund",
  ];

  const handleRoleChange = (e) => {
    const role = e.target.value;
    const perms = rolePermissionsMap[role] || [];
    setFormData({ ...formData, role, permissions: perms });
  };

  const togglePermission = (perm) => {
    setFormData((prev) => ({
      ...prev,
      permissions: prev.permissions.includes(perm)
        ? prev.permissions.filter((p) => p !== perm)
        : [...prev.permissions, perm],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await addAdmin(formData);
      setSuccess(true);
      setFormData({
        fullName: "",
        email: "",
        mobilenumber: "",
        role: "Support Agent",
        permissions: [],
      });
      setTimeout(() => setSuccess(false), 3000);
    } catch (err) {
      alert(err.response?.data?.message || "Failed to add admin");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-admin-page">
      {success && (
        <div className="success-banner">Admin added successfully!</div>
      )}

      <form className="add-admin-form" onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group">
            <label>
              Full Name <span className="required-star">*</span>
            </label>

            <input
              type="text"
              value={formData.fullName}
              onChange={(e) =>
                setFormData({ ...formData, fullName: e.target.value })
              }
              required
            />
          </div>
          <div className="form-group">
            <label>
              Email <span className="required-star">*</span>
            </label>
            <input
              type="email"
              value={formData.email}
              onChange={(e) =>
                setFormData({ ...formData, email: e.target.value })
              }
              required
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Phone Number</label>
            <input
              type="text"
              value={formData.mobilenumber}
              onChange={(e) =>
                setFormData({ ...formData, mobilenumber: e.target.value })
              }
            />
          </div>
          <div className="form-group">
            <label>
              Role <span className="required-star">*</span>
            </label>

            <select value={formData.role} onChange={handleRoleChange} required>
              {availableRoles.map((role) => (
                <option key={role} value={role}>
                  {role}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="form-group">
          <label>Permissions</label>
          <div className="permissions-grid">
            {allPermissions.map((perm) => (
              <label key={perm} className="permission-checkbox">
                <input
                  type="checkbox"
                  checked={formData.permissions.includes(perm)}
                  onChange={() => togglePermission(perm)}
                />
                {perm.replace(/_/g, " ").toUpperCase()}
              </label>
            ))}
          </div>
          <small>Select the permissions this admin should have.</small>
        </div>

        <button type="submit" className="btn-primary" disabled={loading}>
          <PersonAddIcon /> {loading ? "Adding..." : "Add Admin"}
        </button>
      </form>
    </div>
  );
};

export default AddAdmin;
